import useLanguage from '@/hooks/useLanguage'
import trackEvent from '@/track/trackEvent'
import getDomains from '@/utils/getDomains'
import { appVersion } from '@/http'
interface RequestOptions extends RequestInit {
  params?: { [key: string]: string | number | any }
}
const _fetch = (url: string, options?: RequestOptions): Promise<any> => {
  options = options || {}
  if (options.params) {
    const queryParams = new URLSearchParams()
    for (const key in options.params) {
      queryParams.append(key, options.params[key]?.toString())
    }
    queryParams.append('_timer', new Date().getTime().toString())
    url = `${url}?${queryParams.toString()}`
    delete options.params
  } else {
    url = `${url}?_timer=${new Date().getTime()}`
  }

  const defaultHeaders = {
    'Content-Type': 'application/json;charset=UTF-8',
    'Web-Id': localStorage.getItem('web_id') || '',
    'App-Version': appVersion,
    'Tz': Intl.DateTimeFormat().resolvedOptions().timeZone || '',
    'accept-language': useLanguage().locale,
    'Entry-Type': getDomains().thirdLevelDomain === 'edu' ? 'edu' : 'main',
    ...options.headers
  }
  // 判断body是否为formData类型
  if (options.body instanceof FormData) {
    // 如果是 FormData，删除 Content-Type 头，确保 fetch 处理边界
    if ('Content-Type' in defaultHeaders) {
      delete (defaultHeaders as { [key: string]: any })['Content-Type']
    }
  }
  const headers = new Headers(defaultHeaders)
  const newOptions: RequestInit = { ...options, headers }
  // return window.fetch(url, newOptions);
  return window
    .fetch(url, newOptions)
    .then(response => {
      if (!response.ok) {
        throw new Error(
          `HTTP error! status: ${response.status}, statusText: ${response.statusText}`
        )
      }
      return response
    })
    .catch(error => {
      // 发送埋点
      trackEvent.track('http_error', {
        http_url: url,
        http_message: error.message
      })
      // 仍然抛出原始错误，不影响外部调用
      throw error
    })
}

export default _fetch
